// redux/slices/provisionSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';

/**
 * Fetch Invalid Project Report
 */
export const fetchInvalidProjectReport = createAsyncThunk(
  'provisionAdmin/fetchInvalidProjectReport',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('googleIdToken');
      const response = await axios.get(
        `${config.apiURL}/get_InvalidProjectReport`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          'Failed to fetch invalid project report',
      );
    }
  },
);

/**
 * ✅ Fetch Lead Responses (with date range)
 */
export const fetchLeadResponses = createAsyncThunk(
  'provisionAdmin/fetchLeadResponses',
  async ({ startDate, endDate }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('googleIdToken');

      const response = await axios.get(`${config.apiURL}/get_LeadResponses`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { startDate, endDate },
      });

      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch lead responses',
      );
    }
  },
);

/**
 * ✅ Fetch Lead Master (with date range)
 */
export const fetchProjectLeadMaster = createAsyncThunk(
  'provisionAdmin/fetchProjectLeadMaster',
  async ({ startDate, endDate }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('googleIdToken');

      const response = await axios.get(
        `${config.apiURL}/get_project_leads_master`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { startDate, endDate },
        },
      );

      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch lead responses',
      );
    }
  },
);

const provisionAdminSlice = createSlice({
  name: 'provisionAdmin',
  initialState: {
    invalidProjectReport: [],
    leadResponses: [],
    ProjectLeadMaster: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearProvisionState: (state) => {
      state.invalidProjectReport = [];
      state.leadResponses = [];
      state.ProjectLeadMaster = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      /* ---------------- Invalid Project Report ---------------- */
      .addCase(fetchInvalidProjectReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvalidProjectReport.fulfilled, (state, action) => {
        state.loading = false;
        state.invalidProjectReport = action.payload;
      })
      .addCase(fetchInvalidProjectReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------------- Lead Responses ---------------- */
      .addCase(fetchLeadResponses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLeadResponses.fulfilled, (state, action) => {
        state.loading = false;
        state.leadResponses = action.payload;
      })
      .addCase(fetchLeadResponses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------------- Project Lead Master ---------------- */
      .addCase(fetchProjectLeadMaster.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectLeadMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.ProjectLeadMaster = action.payload;
      })
      .addCase(fetchProjectLeadMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearProvisionState } = provisionAdminSlice.actions;

export default provisionAdminSlice.reducer;
